export default __webpack_public_path__ + "static/media/pizzas-1.3e6e2e29.jpg";